export const DEFAULT_CURRENCY = {
	name: 'USD',
	symbol: '$'
};
